import { useQuery } from "@tanstack/react-query"
import { UseFormReturn } from "react-hook-form"
import shopCore from "../../core/shop.core"
import { useRouter } from "next/router"
import { DocListFilter } from "../../types/product"



export function useGetSalesLocation() {
  const { query, isReady } = useRouter()

  const result = useQuery({
    queryKey: ["sales-location", query.id],
    queryFn: async (context) => {
      const result = await shopCore.getSalesLocation(context.queryKey[1] as string)
      return result.data
    }, enabled: isReady
  })


  return {
    ...result
  }
}




export function useListSalesLocation(methods: UseFormReturn<DocListFilter, any>) {

  const result = useQuery({
    queryKey: ["sales-location"],
    queryFn: async (context) => {
      const result = await shopCore.listSalesLocation(context.queryKey)
      return result.data
    }
  })


  return {
    methods,
    ...result
  }
}
